import React, { useState ,useEffect} from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useData } from '../contexts/DataContext';
import { Card, CardContent, CardDescription, CardHeader, CardTitle} from '../components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { Button } from '../components/ui/button';

import { Badge } from '../components/ui/badge';
import { Settings, Users, Calendar, Shield, Plus, UserPlus, CheckSquare2 } from 'lucide-react';
import Layout from '../components/Layout';
import CreateMeetingModal from '../components/CreateMeetingModal';
import CreateUserModal from '../components/CreateUserModal';
import UserManagement from '../components/UserManagement';
import MeetingManagement from '../components/MeetingManagement';
import TaskManagement from '../components/TaskManagement';
import CalendarView from '../components/CalendarView';
import CreateDepartmentModal from '../components/CreateDepartmentModal';
import Department from '../components/Department';
import TasksTable from '../components/TasksTable';
import MyTaskManagement from '../components/MyTask/MyTaskManagement';
import ReviewTasksTable from '../components/ReviewTasksTable';


const AdminDashboard = () => {
  const { user } = useAuth();
  const { meetings, users, loading, getTaskAnalytics, getDepartmentStats, getMeetingStats, getReviewAnalytics } = useData();
  const [isCreateMeetingModalOpen, setIsCreateMeetingModalOpen] = useState(false);
  const [isCreateDepartmentModalOpen, setIsCreateDepartmentModalOpen] = useState(false);
  const [isCreateUserModalOpen, setIsCreateUserModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState(() => {
    // Initialize from localStorage if available
    const storedTab = localStorage.getItem('adminDashboardTab');
    return storedTab || 'meetings';
  });

  useEffect(() => {
    // Save to localStorage whenever activeTab changes
    localStorage.setItem('adminDashboardTab', activeTab);
  }, [activeTab]);

  if (loading) {
    return (
      <Layout>
        <div className="space-y-6">
          <div className="loading-shimmer h-8 w-64 rounded-lg"></div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[1, 2, 3].map(i => (
              <div key={i} className="loading-shimmer h-32 rounded-xl"></div>
            ))}
          </div>
        </div>
      </Layout>
    );
  }

  const taskAnalytics = getTaskAnalytics();
  const departmentStats = getDepartmentStats();
  const meetingStats = getMeetingStats();
  const reviewAnalytics = getReviewAnalytics();

  return (
    <Layout>
      <div className="space-y-1 fade-in">
        {/* Header */}
        <div className="sm:hidden flex  sm:flex-row justify-between items-start sm:items-center gap-4">
          <div className='w-fit bg-gradient-to-r from-blue-50 to-blue-100 rounded-lg p-2'>
            <h1 className="text-sm   font-bold text-gray-900" data-testid="admin-dashboard-title">
              Dashboard
            </h1>
            
          </div>
          <div className="block sm:hidden w-full">
            <Button
              onClick={() => setIsCreateMeetingModalOpen(true)}
              className="btn-gold w-full sm:w-auto"
              data-testid="create-meeting-btn-mobile"
            >
              <Plus className="w-4 h-4 mr-2" />
              Create Meeting
            </Button>
          </div>
          
        </div>

       


        {/* Admin Tabs */}
        <Tabs 
          value={activeTab}
          onValueChange={setActiveTab}
          className="space-y-2"
        >
          <TabsList className="grid w-full h-22 sm:h-auto grid-cols-3 lg:w-auto lg:grid-cols-6">
          <TabsTrigger value="meetings" data-testid="meetings-tab">Meetings</TabsTrigger>
            <TabsTrigger value="calendar" data-testid="calendar-tab">Calendar</TabsTrigger>
            <TabsTrigger value="tasks" data-testid="tasks-tab" className="flex items-center gap-2">Tasks <span className="text-xs  px-2 py-1 bg-red-500 text-white rounded-md"> {taskAnalytics.total}</span></TabsTrigger>
            <TabsTrigger value="mytasks" data-testid="mytasks-tab">My Tasks</TabsTrigger>
            <TabsTrigger value="review" data-testid="review-tab" className="flex items-center gap-2">Review <span className="text-xs  px-2 py-1  bg-red-500 text-white rounded-md"> {reviewAnalytics.total}</span></TabsTrigger>
            <TabsTrigger value="users" data-testid="users-tab">Users</TabsTrigger>
          </TabsList>

          <TabsContent value="users">
            <UserManagement />
          </TabsContent>

          <TabsContent value="meetings">
            <MeetingManagement />
          </TabsContent>

          <TabsContent value="tasks">
            <TaskManagement />
          </TabsContent>

          <TabsContent value="calendar">
            <CalendarView showAllMeetings adminView />
          </TabsContent>

          <TabsContent value="mytasks">
            <MyTaskManagement />
          </TabsContent>
          
          <TabsContent value="review">
            <ReviewTasksTable />
          </TabsContent>
        </Tabs>
      </div>


      <CreateMeetingModal 
        open={isCreateMeetingModalOpen} 
        onClose={() => setIsCreateMeetingModalOpen(false)} 
      />

      <CreateDepartmentModal 

        open={isCreateDepartmentModalOpen} 

        onClose={() => setIsCreateDepartmentModalOpen(false)} 
      />

      <CreateUserModal 
        open={isCreateUserModalOpen} 
        onClose={() => setIsCreateUserModalOpen(false)} 
      />
    </Layout>
  );
};

export default AdminDashboard;